import { createContext, useContext, useState } from "react";

// Holds the single DOM node (rendered by <Navbar/>) into which any public page
// portals its contextual secondary nav. Lifting the slot rather than the
// content keeps page state local and avoids re-rendering the whole tree on
// every sub-nav change.
const SubNavSlotContext = createContext({ slot: null, setSlot: () => {} });

export function SubNavProvider({ children }) {
  const [slot, setSlot] = useState(null);
  return (
    <SubNavSlotContext.Provider value={{ slot, setSlot }}>
      {children}
    </SubNavSlotContext.Provider>
  );
}

export function useSubNavSlot() {
  return useContext(SubNavSlotContext);
}
